module.exports = __webpack_public_path__ + "static/img/drilling11.028b7314.png";